module.exports = __webpack_public_path__ + "img/import-field-format.6b875000.png";